import { createSlice } from '@reduxjs/toolkit';

const initialData = {
  isLocationScope: true,
  selectedOne: null,
  isAllSelected: false,

  isLocationSelected: [],
  isSpecificLocationSelected: [],
  isMachineSelected: [],

  selectedLocations: [],
  selectedSpecificLocations: [],
  selectedMachines: [],

  displaySelectBox: false,

  isApplied: false,
  inputTemp: 0,
  isF: false,
  scheduleList: [
    {
      start: { date: null, time: null },
      end: { date: null, time: null },
      inputTemp: null,
      isF: null,
    },
  ],
};

const initialState = {
  instantHeat: initialData,
  snowSensor: initialData,
  optionalConstant: initialData,
  heatingSchedule: initialData,
  windFactor: initialData,
  ats: initialData,
  shutOff: initialData,
  fanOnly: initialData,
};

const masterControlSelectByLocationSlice = createSlice({
  name: 'masterControlSelectByLocation',
  initialState,
  reducers: {
    handleResetSelectedOneByLocation: (state) => {
      state.instantHeat.selectedOne = null;
      state.snowSensor.selectedOne = null;
      state.optionalConstant.selectedOne = null;
      state.heatingSchedule.selectedOne = null;
      state.windFactor.selectedOne = null;
      state.ats.selectedOne = null;
      state.shutOff.selectedOne = null;
      state.fanOnly.selectedOne = null;
    },
    handleSelectedOneByLocation: (state, action) => {
      state[action.payload.controller].selectedOne = action.payload.selectedOne;
    },
    handleSelectAllByLocation: (state, action) => {
      state[action.payload.controller].isAllSelected = action.payload.status;
    },
    handleLocationSelectByLocation: (state, action) => {
      state[action.payload.controller].isLocationSelected = action.payload.arr;
    },
    handleSpecificLocationSelectByLocation: (state, action) => {
      state[action.payload.controller].isSpecificLocationSelected =
        action.payload.arr;
    },
    handleMachineSelectByLocation: (state, action) => {
      state[action.payload.controller].isMachineSelected = action.payload.arr;
    },
    handleMachineSelectAllByLocation: (state, action) => {
      state[action.payload.controller].isMachineSelected[
        action.payload.locationIdx
      ][action.payload.machineIdx] = true;
    },

    handleAddLocationsByLocation: (state, action) => {
      state[action.payload.controller].selectedLocations = action.payload.arr;
    },
    handleAddSpecificLocationsByLocation: (state, action) => {
      state[action.payload.controller].selectedSpecificLocations =
        action.payload.arr;
    },
    handleAddMachinesByLocation: (state, action) => {
      state[action.payload.controller].selectedMachines = action.payload.arr;
    },
    handleMachineSelectAltByLocation: (state, action) => {
      state[action.payload.controller].isMachineSelected[
        action.payload.locationIdx
      ][action.payload.machineIdx] = action.payload.status ?? true;
    },
    handleMachineSelectWithSpecLocationAltByLocation: (state, action) => {
      state[action.payload.controller].isMachineSelected[
        action.payload.locationIdx
      ][action.payload.specLocationIdx][action.payload.machineIdx] =
        action.payload.status ?? true;
    },

    handleResetAllSelectByLocation: (state, action) => {
      return { ...initialState };
    },
    handleDisplaySelectBoxByLocation: (state, action) => {
      state[action.payload.controller].displaySelectBox =
        !state.displaySelectBox;
    },
    handleDisplaySelectBoxWithActionByLocation: (state, action) => {
      state.displaySelectBox = action.payload;
    },
    handleApplyWithTempByLocation: (state, action) => {
      state[action.payload.controller].isApplied =
        !state[action.payload.controller].isApplied;
      state[action.payload.controller].inputTemp = action.payload.temp;
    },
    handleSetScheduleListByLocation: (state, action) => {
      state.heatingSchedule.scheduleList[action.payload.index] = {
        start: action.payload.start,

        end: action.payload.end,
        inputTemp: action.payload.inputTemp,
        isF: action.payload.isF,
      };

      state.heatingSchedule.scheduleList[action.payload.index + 1] = {
        start: { date: null, time: null },
        end: { date: null, time: null },
        inputTemp: null,
        isF: null,
      };
    },
  },
});

export default masterControlSelectByLocationSlice;
export const selectMCByLocation = (state) =>
  state.masterControlSelectByLocation;
export const {
  handleSelectAllByLocation,
  handleSelectedOneByLocation,
  handleLocationSelectByLocation,
  handleSpecificLocationSelectByLocation,
  handleMachineSelectByLocation,
  handleAddLocationsByLocation,
  handleAddSpecificLocationsByLocation,
  handleAddMachinesByLocation,
  handleMachineSelectAllByLocation,
  handleResetAllSelectByLocation,
  handleDisplaySelectBoxByLocation,
  handleDisplaySelectBoxWithActionByLocation,
  handleMachineSelectAltByLocation,
  handleMachineSelectWithSpecLocationAltByLocation,

  handleApplyWithTempByLocation,
  handleSetScheduleByLocation,
  handleResetSelectedOneByLocation,
} = masterControlSelectByLocationSlice.actions;
